export const findApiLocale = (authorized: boolean, locale: string): string =>
  authorized ? '' : locale
